import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["checkbox", "requiredInput", "dependentElement"]

  connect() {
    this.update()
  }

  requiredInputTargetConnected() {
    this.update()
  }

  update() {
    const checkboxesChecked = this.checkboxTargets.every(checkbox => checkbox.checked)
    const inputsFilled = this.requiredInputTargets.every(input => input.value.trim().length > 0)
    this.dependentElementTargets.forEach(element => element.disabled = !(checkboxesChecked && inputsFilled))
  }
}
